import { useTranslations } from "next-intl";
import { Link } from "@components/core";

function ClosetActionSent ({ closet }) {
  const t = useTranslations("closets");

  return (
    <div className="pb-3">
      {closet?.delivery_follow_up_url && (
        <Link
          className="link-primary"
          noUnderline
          href={closet?.delivery_follow_up_url}
          target="_blank"
          rel="noreferrer"
        >
          {t("state.sent.closet_action_button_title")}
        </Link>
      )}
    </div>
  );
};

export default ClosetActionSent;
